var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"pElU7UdyXWbq-w7YdGLJp"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://1e6015a19b9cd275a191b8e04da8e945@sentry.eunoia.es/8',
  environment: process.env.entorno === undefined ? 'prod' : process.env.entorno, // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,
  enabled: false,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
